import react from 'react';
const TableRowHeader = (props) => {
  return (
    <tr className={props.className ? props.className : 'bg-darkBlueLight'}>{props.children}</tr>
  );
};
export default TableRowHeader;
